/* eslint-disable */ import { memoEval, violationsComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const narrowEnglishTurnedBaseComponents = [
    attachComponent.withComponent(violationsComponent, 'default', true).withEntity('NarrowEnglishTurnedBase').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$violations
        ], ($violations)=>({
            violations: $violations
        })))
];

//# sourceMappingURL=narrow-english-turned-base.js.map